import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule, ColumnChooserService, PageService, SortService, FilterService, ResizeService } from '@syncfusion/ej2-angular-grids';
import { ManageComponent } from './manage.component';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgxUiLoaderModule,  } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { NgSelectModule } from '@ng-select/ng-select';
import { ManageRoutingModule } from './manage-routing.module';
import { dropdownModule } from 'src/app/dropdown/dropdown.module';
@NgModule({
  declarations: [
    ManageComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MultiselectDropdownModule,
    NgSelectModule,
    GridModule,
    DragDropModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    ManageRoutingModule,
    dropdownModule
  ],
  providers: [ ColumnChooserService, PageService, SortService, FilterService, ResizeService],
})
export class ManageModule { }
